import { AnimatePresence, useReducedMotion } from 'motion/react';
import React from 'react';

import {
  OptionItemSquareLightStyles,
  OptionItemSquareLightTitleStyles,
} from './OptionItemSquareLight.styles';

export const OptionItemSquareLight: React.FC<{
  bgSrc: string;
  title: string;
  isSelected: boolean;
  onClick: () => void;
  TEST_ID?: string;
  animate?: boolean;
  show: boolean;
}> = ({ bgSrc, title, isSelected, onClick, TEST_ID, animate, show }) => {
  const shouldReduceMotion = useReducedMotion();
  const canAnimate = animate && !shouldReduceMotion;

  if (canAnimate) {
    const scale = isSelected ? 1.03 : 0.97;

    return (
      <AnimatePresence>
        {show && (
          <OptionItemSquareLightStyles
            className="option-item-square-light"
            isSelected={isSelected}
            bgSrc={bgSrc}
            onClick={onClick}
            data-testid={TEST_ID}
            initial={{
              opacity: 0.5,
              scale: 0.8,
            }}
            animate={{
              opacity: 1,
              scale: scale,
            }}
            exit={{
              opacity: 0.5,
              scale: 0.8,
            }}
            transition={{
              duration: 0.3,
              bounce: 0.5,
            }}
          >
            <OptionItemSquareLightTitleStyles variant="label-large">
              {title}
            </OptionItemSquareLightTitleStyles>
          </OptionItemSquareLightStyles>
        )}
      </AnimatePresence>
    );
  }

  const scale = isSelected ? 1.03 : 1;

  return (
    <OptionItemSquareLightStyles
      isSelected={isSelected}
      bgSrc={bgSrc}
      onClick={onClick}
      data-testid={TEST_ID}
      initial={{
        scale,
      }}
      animate={{
        scale,
      }}
      className="option-item-square-light"
    >
      <OptionItemSquareLightTitleStyles variant="label-large">
        {title}
      </OptionItemSquareLightTitleStyles>
    </OptionItemSquareLightStyles>
  );
};
